import IndigoServiceClient from 'communication/IndigoServiceClient';
import { ApiRequestOptions } from 'communication/ApiCallInfo';
import IndigoApiError from 'communication/IndigoApiError';
import { VenueMappingsResponse } from 'widgets/darkVenueHeatmap/venueMappings/types.ts';

export interface DarkVenueMappingsApiOptions {
    indigoServiceClient: IndigoServiceClient;
}

export class DarkVenueMappingsApi {
    private indigoServiceClient: IndigoServiceClient;

    public constructor(options: DarkVenueMappingsApiOptions) {
        this.indigoServiceClient = options.indigoServiceClient;
    }

    public async fetchMappings(
        options: ApiRequestOptions
    ): Promise<VenueMappingsResponse> {
        const url = 'darkVenueHeatmap/venueMappings';

        return await IndigoApiError.runHandlingErrorsAsync(
            `Dark Venue Mappings`,
            async () => {
                return await this.indigoServiceClient.get<VenueMappingsResponse>(
                    url,
                    options
                );
            }
        );
    }
}
